/**
 * @generated SignedSource<<f4a2a667aa7bbad0bcb54688e1707d45>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type channel_AtlassianSearchPage$data = {
  readonly entity: {
    readonly associatedWith?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly entity: {
            readonly __typename: "ExternalConversation";
            readonly channelId: string | null;
            readonly displayName: string | null;
          } | {
            // This will never be '%other', but we need some
            // value in case none of the concrete values match.
            readonly __typename: "%other";
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "channel_AtlassianSearchPage";
};
export type channel_AtlassianSearchPage$key = {
  readonly " $data"?: channel_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"channel_AtlassianSearchPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "channel_AtlassianSearchPage",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "ExternalAssociationConnection",
              "kind": "LinkedField",
              "name": "associatedWith",
              "plural": false,
              "selections": [
                {
                  "concreteType": "ExternalAssociationEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "concreteType": "ExternalAssociation",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "entity",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "ScalarField",
                                  "name": "__typename"
                                },
                                {
                                  "alias": "channelId",
                                  "kind": "ScalarField",
                                  "name": "externalId"
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "displayName"
                                }
                              ],
                              "type": "ExternalConversation"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ],
          "type": "ExternalMessage"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};

(node as any).hash = "65025c6fc5eb039a81cc5f05b1245093";

export default node;
